import { render } from "./Badges.vue?vue&type=template&id=f5015054"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"
script.render = render

export default script